function hashString(value) {
  let hash = 1779033703 ^ value.length;
  for (let index = 0; index < value.length; index += 1) {
    hash = Math.imul(hash ^ value.charCodeAt(index), 3432918353);
    hash = (hash << 13) | (hash >>> 19);
  }
  return () => {
    hash = Math.imul(hash ^ (hash >>> 16), 2246822507);
    hash = Math.imul(hash ^ (hash >>> 13), 3266489909);
    return (hash ^= hash >>> 16) >>> 0;
  };
}

function mulberry32(seed) {
  return () => {
    let value = (seed += 0x6d2b79f5);
    value = Math.imul(value ^ (value >>> 15), value | 1);
    value ^= value + Math.imul(value ^ (value >>> 7), value | 61);
    return ((value ^ (value >>> 14)) >>> 0) / 4294967296;
  };
}

export function createSessionSeed(images) {
  const existing = sessionStorage.getItem('maldet-gallery-seed');
  if (existing) return existing;

  const imageFingerprint = images.map((image) => image.filename).join('|');
  const seed = `${Date.now()}-${imageFingerprint.length}-${Math.random().toString(36).slice(2)}`;
  sessionStorage.setItem('maldet-gallery-seed', seed);
  return seed;
}

export function shuffleImages(images, seed) {
  const seedFactory = hashString(seed || images.map((image) => image.filename).join('|'));
  const random = mulberry32(seedFactory());
  const nextImages = [...images];

  for (let index = nextImages.length - 1; index > 0; index -= 1) {
    const swapIndex = Math.floor(random() * (index + 1));
    [nextImages[index], nextImages[swapIndex]] = [nextImages[swapIndex], nextImages[index]];
  }

  return nextImages;
}

const landscapeVariants = [
  'bleed-left',
  'cinema-right',
  'split-wide',
  'low-slung',
  'poster-lock',
  'rail-cut'
];

const portraitVariants = ['vertical-cut', 'narrow-scream', 'body-offset', 'portrait-lock'];

export function buildStoryLayout(images, seed) {
  const random = mulberry32(hashString(`${seed}-layout`)());
  const shuffled = shuffleImages(images, seed);

  return shuffled.map((image, index) => {
    const isPortrait = image.orientation === 'portrait';
    const variants = isPortrait ? portraitVariants : landscapeVariants;
    const variant = variants[index % variants.length];
    const drift = Math.round((random() - 0.5) * 32);
    const depth = Number((0.75 + random() * 0.7).toFixed(2));
    const rotate = Number(((random() - 0.5) * 2.4).toFixed(2));
    const focus = index % 7 === 0;

    return {
      ...image,
      index,
      variant,
      focus,
      style: {
        '--drift': `${drift}px`,
        '--depth': depth,
        '--tilt': `${rotate}deg`
      }
    };
  });
}
